import React, {useEffect, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import {getColoredImage} from 'shared/helpers';
import styled from 'styled-components';

interface SVGImageProps {
    src: string;
    alt: string;
    top: number;
    left: number;
    scale: number;
    loadingStatus: boolean;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export const SVGImage = ({
    src,
    alt,
    top,
    left,
    scale = 150,
    loadingStatus,
}: SVGImageProps) => {
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState<string>();

    useEffect(() => {
        if (src) {
            fetch(src, {
                headers: {
                    'Cache-Control': 'max-age=3600', // or 'max-age=3600' for 1 hour caching
                },
            })
                .then((response) => response.text())
                .then((data: string) => {
                    if (data) {
                        const image = getColoredImage(
                            data,
                            ['#214480', '#204380', '#204480'],
                            'white'
                        );
                        setImage(image);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [src]);

    if (loading || loadingStatus)
        return <AbsoluteSpinner animation="border" variant="light" size="sm" />;

    if (image)
        return (
            <AbsoluteImage
                src={image}
                alt={alt}
                $top={top}
                $left={left}
                $scale={scale}
            />
        );
};

const AbsoluteSpinner = styled(Spinner)`
    position: absolute;
    top: 5px;
    left: 5px;
`;

const AbsoluteImage = styled.img<{$top: number; $left: number; $scale: number}>`
    position: absolute;
    width: ${({$scale}) => $scale}%;
    top: ${({$top}) => $top}px;
    left: ${({$left}) => $left}px;
`;
